import { defineAsyncComponent } from 'vue'

const customIconNameList = [];

export default {
	install(app) {
		//auto register components
		// 扫描 ./components 目录的子目录下的所有.vue 文件
		// 所有子目录为组件名
		const moduleFiles = import.meta.glob('./**/Index.vue')
		// 全局注册组件
		for(let path in moduleFiles) {
		    let segs = path.split('/')
			// 按照指定格式取得 componentName
			const componentName = 'Icon' + segs[segs.length - 2]
			
			customIconNameList.push(componentName)
		    // 注册
		    app.component(componentName, defineAsyncComponent(moduleFiles[path]));
		}
		
		app.config.globalProperties.customIconNameList = customIconNameList;
	}
}